import { useIsMobile } from "@shared/hooks/useIsMobile";
import Image from "next/image";
import { FC } from "react";
import Link from "next/link";
import FilledLeftIcon from "@svg/new-design/filled-left";
import { twMerge } from "tailwind-merge";
import { useLayoutContext } from "@context/layout";
import { useRouter } from "next/router";
import useSubscriptionExperiments from "@shared/hooks/useSubscriptionExperiments";
import { Button, BUTTON_SIZE, BUTTON_VARIANT } from "../button";

interface Props {
  className?: string;
}

const SubscriptionBanner: FC<Props> = ({ className }) => {
  const isMobile = useIsMobile(640);
  const { pathname } = useRouter();
  const { subscriptionData } = useLayoutContext();
  const isCertificatePage = pathname.includes("/certificate");
  const { handleLogExperimentSubRecommender } = useSubscriptionExperiments();

  const hasSubscription = Boolean(subscriptionData?.is_active);
  if (hasSubscription) return null;

  // """" DO NOT DELETE THESE COMMENTS - NEED THEM BACK SOON *****

  // const [isCloseAppBanner, setIsCloseAppBanner] = useState<boolean>(false);

  // useEffect(() => {
  //   const isCloseSubscriptionBanner =
  //     Boolean(getCookie().get(COOKIE_SHOW_SUBSCRIPTION_BANNER)) === true;

  //   setIsCloseAppBanner(isCloseSubscriptionBanner);
  // }, []);

  // const closeAppBanner = () => {
  //   const exp = 10;
  //   getCookie().set(COOKIE_SHOW_SUBSCRIPTION_BANNER, true, {}, exp);
  //   setIsCloseAppBanner(true);
  // };

  return (
    <div
      className={twMerge(
        "fixed z-layout w-full py-2 px-3 h-10 bg-fds-brand-select flex items-center justify-between",
        isMobile ? "flex" : "hidden",
        isCertificatePage ? "bottom-fds-68" : "bottom-16",
        className
      )}
    >
      <Link
        passHref
        prefetch={false}
        href="/subscription"
        onClick={() =>
          handleLogExperimentSubRecommender({
            position: "bottom-sticky-banner",
          })
        }
      >
        <div className="flex items-center gap-x-1.5">
          <Image
            src="https://faradars.org/wp-content/uploads/2026/05/20/sub-icon.svg"
            width={24}
            height={24}
            alt="اشتراک فرادرس"
          />
          <p className="headline-xxsm text-fds-on-inverse">
            دسترسی به همه آموزش‌ها، با یک اشتراک
          </p>
        </div>
      </Link>

      <Button
        variant={BUTTON_VARIANT.OUTLINE}
        size={BUTTON_SIZE.SMALL}
        className="border-white text-white hover:text-white hover:border-white"
        endIcon={<FilledLeftIcon />}
        href="/subscription"
        onClick={() =>
          handleLogExperimentSubRecommender({
            position: "bottom-sticky-banner",
          })
        }
      >
        کلیک کنید
      </Button>
    </div>
  );
};

export default SubscriptionBanner;
